import { apiClient } from "@/api/client";
import type { DriverLocation } from "@/types/domain";

/**
 * GET /location/admin/drivers (apps/location-service location.service.ts
 * adminLiveDrivers) — snapshot of every online driver's last-known position
 * from Redis GEO, for the Live Rides map's initial load. Live updates after
 * that come from the `admin:driver:location` Socket.IO event, not polling.
 */
export const locationApi = {
  getOnlineDrivers: () =>
    apiClient.get<DriverLocation[]>("/location/admin/drivers").then((r) => r.data),
};
